import React, {useState} from "react";
import "../General/General.css";
import {InputAdornment, TextField} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from '@mui/material/Autocomplete';
import {getHarvestClientsByName} from "../../utilities/harvestAPI";
import keycloak from "../../Keycloak";
import CustomPaper from "../General/DropdownPaper";

const HarvestClientSearch = ({harvestClientId, harvestClientName, onChangeMethod}) => {
    const style = {
        "& label.Mui-focused": {
            color: "#FF6600",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#FF6600",
            },
        },
    };

    const [clientNames, setClientNames] = useState([]);
    const [clientId, setClientIdValue] = useState('');

    const handleSearch = async (event) => {
        const searchQuery = event.target.value;
        console.log("searchQuery is " + searchQuery);

        const harvestClients = await getHarvestClientsByName(searchQuery, keycloak.token);
        console.log("Harvest clients " + harvestClients)
        if (harvestClients.length > 0) {
            console.log(harvestClients);
            const clientNames = harvestClients.map((client) => ({
                id: client.id,
                name: client.name
            }));
            setClientNames(clientNames);
        } else {
            setClientNames([]);
            console.log("No data returned");
        }
    };

    const onChangeHandler = async (event, value) => {
        if (value) {
            const dropDownHarvestClientId = value.id;
            localStorage.setItem('dropDownHarvestClientId', dropDownHarvestClientId);
            setClientIdValue(value.id);
            console.log("Harvest Client ID: " + dropDownHarvestClientId);
            onChangeMethod(value.id, value.name);
        }
        console.log(clientId);
    }

    return (
        <Autocomplete
            PaperComponent={CustomPaper}
            className="inputWidth"
            data-testid='HarvestClientAutoComplete'
            id="harvestClient"
            defaultValue={harvestClientId && harvestClientName ? {id: harvestClientId, name: harvestClientName} : null}
            options={clientNames}
            getOptionLabel={(option) => option.name}
            onChange={onChangeHandler}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Client's harvest*"
                    variant="outlined"
                    defaultValue="Intengo"

                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {params.InputProps.endAdornment}
                                <InputAdornment position="end">
                                    <SearchIcon/>
                                </InputAdornment>
                            </React.Fragment>
                        ),
                    }}
                    onFocus={handleSearch}
                    sx={style}
                />
            )}
        />
    )
};
export default HarvestClientSearch;